import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class CalendarService {
  label$ = new Subject();
  monthChange$ = new Subject();
}
